import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toNonAccentVietnamese } from "../../base/util/functions";
import { isScreenVideoShared } from "../../screen-share/functions";
import { COMMANDS } from "../../mod-command/constants";
import { getModCommand } from "../../mod-command/functions";
const useDialogPinParticipant = () => {
    const { remote, local, localScreenShare, sortedRemoteScreenshares } = useSelector((state) => state['features/base/participants']);
    const pinnedAllPariticipantId = useSelector((state) => getModCommand(state, COMMANDS.PIN_PARTICIPANT.COMMAND)?.value);
    const [tmpPinId, setTmpPinId] = useState(pinnedAllPariticipantId);
    const [valueFilter, setValueFilter] = useState('');
    const [remoteFilter, setRemoteFilter] = useState(() => {
        let _remote = Array.from(remote.values());
        return _remote;
    });
    let _sortedRemoteScreenshares = Array.from(sortedRemoteScreenshares.keys());
    if (isScreenVideoShared(APP.store.getState())) {
        _sortedRemoteScreenshares.push(local?.id);
    }
    useEffect(() => {
        if (Array.from(APP.store.getState()['features/base/participants'].remote.values()).length) {
            if (valueFilter)
                setRemoteFilter(() => Array.from(APP.store.getState()['features/base/participants'].remote.values()).filter((p) => {
                    const displayNameConvert = toNonAccentVietnamese(p.name)?.toLowerCase();
                    if (displayNameConvert?.includes(toNonAccentVietnamese(valueFilter?.trim())?.toLowerCase())
                        ||
                            p.email?.includes(valueFilter?.trim())) {
                        return p;
                    }
                }));
            else
                setRemoteFilter(Array.from(APP.store.getState()['features/base/participants'].remote.values()));
        }
        else
            setRemoteFilter([]);
    }, [valueFilter]);
    useEffect(() => {
        if (tmpPinId) {
            setRemoteFilter((prev) => Array.from(APP.store.getState()['features/base/participants'].remote.values()).filter((p) => p?.id !== tmpPinId));
        }
        else
            setRemoteFilter(Array.from(APP.store.getState()['features/base/participants'].remote.values()));
    }, [tmpPinId]);
    return {
        local,
        remoteFilter,
        pinnedAllPariticipantId,
        tmpPinId,
        setTmpPinId,
        valueFilter,
        setValueFilter,
        _sortedRemoteScreenshares,
        localScreenShare
    };
};
export default useDialogPinParticipant;
